import { jsx as _jsx } from "react/jsx-runtime";
import { BannerGroup } from "./group.js";
import { useBanner } from "../../../contexts/banner.js";
import { GroupList } from "../../common/groups/groupList.js";
const BannerGroupList = ()=>{
    const { groups } = useBanner();
    const useGroups = groups.filter(({ items })=>items.length);
    return /*#__PURE__*/ _jsx(GroupList, {
        children: useGroups.map((group)=>/*#__PURE__*/ _jsx(BannerGroup, {
                group: group
            }, group.id))
    });
};
export { BannerGroupList };
